import React from 'react';
import { Button } from 'primereact/button';
import useVehicleParkReportData from './hooks/useVehicleParkReportData';
import VehicleParkReportTable from './components/VehicleParkReportTable';
import { useLanguage } from '../../../contexts/LanguageContext';
import GenericFileExportButton from '../../../components/common/GenericFileExportButton';
import { useLazyExportVehicleParkToExcelQuery } from '../../../api/endpoints/vehicleParkReport';

const VehicleParkReportPage = () => {
    const { th } = useLanguage();

    const { apiData, isLoading, lazyParams, sortField, sortOrder, activeFilters, exportParams, onPage, onSort, handleFilterChange, initFilters } = useVehicleParkReportData();

    return (
        <div className="card">
            <div className="flex justify-content-between align-items-center mb-4">
                <h1 className="m-0">{th('vehicleParkReport.title')}</h1>
                <div className="flex gap-2">
                    <Button icon="pi pi-filter-slash" className="p-button-outlined p-button-secondary" onClick={initFilters} tooltip={th('filter.reset')} tooltipOptions={{ position: 'left' }} />
                    <GenericFileExportButton
                        useExportQuery={useLazyExportVehicleParkToExcelQuery}
                        exportParams={exportParams}
                        buttonLabel={th('common.export') || 'Excel'}
                        buttonClassName="p-button-success"
                        icon="pi pi-file-excel"
                        fileNameExtractor={(result) => result?.fileName || 'arac_park.zip'}
                        dataExtractor={(result) => result?.fileBase64}
                        contentTypeExtractor={(result) => result?.contentType}
                    />
                </div>
            </div>

            <VehicleParkReportTable
                items={apiData?.items}
                totalCount={apiData?.totalCount}
                loading={isLoading}
                lazyParams={lazyParams}
                onPage={onPage}
                activeFilters={activeFilters}
                onFiltersChange={handleFilterChange}
                sortField={sortField}
                sortOrder={sortOrder}
                onSortChange={onSort}
            />
        </div>
    );
};

export default VehicleParkReportPage;
